import React from "react";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import EditorialMarquee from "@/components/site/EditorialMarquee";
import { History, Mission, Services, Community, OpenSpace, Funding } from "@/components/site/Sections";
import Gallery from "@/components/site/Gallery";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Navbar />
      <Hero />
      <EditorialMarquee />
      <History />
      <Mission />
      <Services />
      <Community />
      <OpenSpace />
      <Gallery />
      <Funding />
      <Contact />
      <Footer />
    </main>
  );
}
